<div class="modal-header">
  <input type="text" class="form-control search-input" placeholder="Поиск" [(ngModel)]="search" (keyup)="filterItems()" />

  <div class="count">
    {{key === 'supervisor' ? 'Супервайзеры:' : ( search.length === 0 ? 'Количество организаций:': 'Найдено организаций:')}} <strong> &nbsp; {{items.length}}</strong>
  </div>
</div>

<app-modal-window *ngIf="showEditOrganizationModal" [title]="editingOrganizationBIN ? 'Редактирование организации': 'Добавление организации'" [visible]="showEditOrganizationModal" [height]="600" (close)="showEditOrganizationModal = $event">
  <app-add-organization [organization]="editableOrganization" [key]="key" (closed)="closeAddOrganization($event)"></app-add-organization>
</app-modal-window>

<div class="items-wrapper">
  <div class="items">
    <ng-container *ngIf="!loading">
      <div class="item" *ngFor="let item of items" [ngClass]="{'active': item.active, 'editing-organization': item.bin === editingOrganizationBIN}" (click)="selectItemWrapper(item)">
        <ng-container [ngSwitch]="key">
          <ng-container *ngSwitchCase="'supervisor'">
            {{ item.name || '' }}
            {{ item.phone || '' }}
          </ng-container>
          <ng-container *ngSwitchCase="'curators'">
            {{ item.departmentTitle || '' }}
            {{ item.phoneNumber || '' }}
            {{ item.name || '' }}
            {{ item.userID || '' }}
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ item.bin || '' }}
            {{ item.title || '' }}
          </ng-container>
        </ng-container>


        <div class="icon_column" (click)="editOrganization(item, $event)" *ngIf="key !== 'supervisor' && key !== 'curators'">
          <span class="icon-edit"></span>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="loading">
    <div class="loading"></div>
  </ng-container>
</div>


<div class="modal-footer">
  <div class="btn btn-apply" (click)="showAddObjectModal()" *ngIf="key !== 'supervisor' && key !== 'curators'"> Добавить организацию </div>
  <div class="btn btn-cancel" (click)="close()"> Отмена </div>
</div>
